<template>
  <div class="row">
    <div class="col-2"></div>
    <div class="col">
      <form v-if="fields.length > 0">
        <h3 style="text-align: center">Visualização do Formulário</h3>
        <div class="question-form">
          <h5 class="label-form" style="text-align: center">{{ formBuilder.nomeForm }}</h5>
        </div>

        <div class="question-form" v-for="(field, index) in fields" :key="index">
          <label :for="field.id" class="label-form">{{ index + 1 }}. {{ field.label }}<b style="color: red; font-size: 15px; margin-left: 5px" v-if="field.required">*</b></label>

          <input class="form-control form-input-component" v-if="field.type === 'text'" :id="'questao' + field.id" :name="field.id" type="text" disabled />

          <textarea class="form-control form-input-component" v-if="field.type === 'textarea'" :id="'questao' + field.id" :name="field.id" disabled></textarea>

          <select class="form-control form-input-component" v-if="field.type === 'select'" :id="'questao' + field.id" disabled>
            <option v-for="(option, optionIndex) in field.options" :key="optionIndex" :value="option.value">
              {{ option.label }}
            </option>
          </select>

          <div v-if="field.type === 'radio'">
            <div class="form-check" v-for="(option, optionIndex) in field.options" :key="optionIndex">
              <input class="form-check-input" type="radio" name="flexRadioDefault" disabled />
              <label class="form-check-label">
                {{ option.label }}
              </label>
            </div>
          </div>

          <div v-if="field.type === 'checkbox'">
            <div class="form-check" v-for="(option, optionIndex) in field.options" :key="optionIndex">
              <input class="form-check-input" type="checkbox" value="{{option}}" disabled id="flexCheckDefault" />
              <label class="form-check-label" for="flexCheckDefault">
                {{ option.label }}
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-3"></div>
  </div>
</template>

<script>
import { getFormBuilderById } from '@/components/service/formBuilderService';

export default {
  name: 'FormBuilderView',
  data() {
    return {
      fields: [],
      idForm: null,
    };
  },
  async created() {
    if (this.$route.query.id) {
      this.idForm = this.$route.query.id;
      await this.recuperarForm();
    }
  },
  methods: {
    async recuperarForm() {
      await getFormBuilderById(this.idForm).then((form) => {
        this.formBuilder = form.data;
        this.fields = this.formBuilder.questoes;
        for (let field of this.fields) {
          this.formCreated['questao' + field.id] = undefined;
        }
      });
    },
  },
};
</script>

<style scoped>
#uploadImg {
  display: none;
}

.question-form {
  background: white;
  padding: 26px;
  border-radius: 10px 10px;
  margin-bottom: 10px;
}

.label-form {
  margin-bottom: 25px;
  font-family: ROBOTO, serif;
  font-size: 23px;
}

.form-check {
  font-size: 18px;
}
</style>
